import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface LogoutDialogData {
  title?: string;
  message?: string;
  info?: string;
  countdownSeconds?: number;
  continueLabel?: string;
  logoutLabel?: string;
}

@Component({
    selector: 'app-confirm-logout',
    template: `<div class="p-5 sm:p-6">
    <h1 class="text-xl font-semibold leading-7 text-slate-900">
      {{ data.title || 'Sign out confirmation' }}
    </h1>

    <div class="mt-3 space-y-3 text-sm leading-6 text-slate-600">
      <p *ngIf="data.message">{{ data.message }}</p>

      <div
        *ngIf="data.countdownSeconds !== undefined"
        class="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-amber-900"
      >
        You will be signed out in
        <strong class="font-semibold">{{ countdownSeconds }}</strong>
        second{{ countdownSeconds === 1 ? '' : 's' }}.
      </div>

      <p *ngIf="data.info">{{ data.info }}</p>
    </div>
  </div>`,
    standalone: false
})
export class AppComfirmLogoutComponent implements OnInit, OnDestroy {
  countdownSeconds = 0;
  private countdownTimerId: number | null = null;

  private deadline = 0;

  constructor(
    public dialogRef: MatDialogRef<AppComfirmLogoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LogoutDialogData,
  ) {}

  ngOnInit(): void {
    const initialSeconds = Math.max(
      0,
      Math.floor(this.data.countdownSeconds ?? 0),
    );
    this.countdownSeconds = initialSeconds;
    this.deadline = Date.now() + initialSeconds * 1000;

    if (this.data.countdownSeconds === undefined) {
      return;
    }

    if (initialSeconds === 0) {
      this.dialogRef.close();
      return;
    }

    if (initialSeconds > 0) {
      this.countdownTimerId = window.setInterval(() => {
        const remainingMs = this.deadline - Date.now();
        this.countdownSeconds = Math.max(0, Math.ceil(remainingMs / 1000));

        if (this.countdownSeconds <= 0) {
          this.clearCountdownTimer();
          // The auth service owns the expiry timeout and logout operation.
          // Closing without a result prevents this display timer from being
          // mistaken for a manual "Sign out" click.
          this.dialogRef.close();
        }
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    this.clearCountdownTimer();
  }

  private clearCountdownTimer(): void {
    if (this.countdownTimerId !== null) {
      window.clearInterval(this.countdownTimerId);
      this.countdownTimerId = null;
    }
  }
}
